var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{class:_vm.comboboxClass,attrs:{"value":_vm.time,"items":_vm.items,"label":_vm.label,"disabled":_vm.disabled,"outlined":"","menu-props":"auto","dense":_vm.dense,"hide-details":"","error":_vm.error,"filter":_vm.filter},on:{"input":_vm.handleInput,"update:search-input":_vm.validateInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }